import 'css-chunksrc/client/scenes/projectCreationForm/projectToolsConfiguration/toggleInput/styles.scss';export default {
  "toggleInput": "_toggleInput_uj9rd_1",
  "bar": "_bar_uj9rd_9",
  "toggled": "_toggled_uj9rd_31"
};